//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH_TABLE = 'budtender/table'
export const PATH = 'budtender'
export const SET_SORT = `${PATH_TABLE}/SET_SORT `
export const SET_PAGE = `${PATH_TABLE}/SET_PAGE`
export const SET_SEARCH_TERM = `${PATH_TABLE}/SET_SEARCH_TERM`
export const SET_RESULT = `${PATH_TABLE}/SET_RESULT`
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_BUDTENDER_REPORT_LIST = `${PATH}/OPEN_BUDTENDER_REPORT_LIST `
